import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFullscreen1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFullscreen1"><Path d="M8 4.5H2.5V10M16 4.5H21.5V10M21.5 14V19.5H16M8 19.5H2.5V14" stroke="currentColor"/></CentralIconBase>;
});

export default IconFullscreen1;
